import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=2515f728&"
import script from "./CategoryCreate.vue?vue&type=script&lang=ts&"
export * from "./CategoryCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports